import billing from './billing'
import cannedReplies from './cannedReplies'
import crm from './crm'
import events from './events'
import flags from './flags'
import inAppCards from './inAppCards'
import integrations from './integrations'
import modals from './modals'
import notifications from './notifications'
import reports from './reports'
import ticketing from './ticketing'
import editor from './editor'
import currentUser from './currentUser'
import widgets from './widgets'
import folders from './folders'
import searches from './searches'
import requests from './requests'

const ducks = {
  billing,
  cannedReplies,
  crm,
  events,
  flags,
  inAppCards,
  integrations,
  modals,
  notifications,
  reports,
  ticketing,
  editor,
  currentUser,
  widgets,
  foldersV2: folders,
  searchV2: searches,
  request: requests,
}

const validDucks = Object.keys(ducks).reduce((result, duckName) => {
  const duck = ducks[duckName]
  // eslint-disable-next-line no-param-reassign
  if (typeof duck === 'function') result[duckName] = duck
  return result
}, {})

export default validDucks

export * as reports from './reports'
